import { CheckCircle2 } from "lucide-react";
import EmptyState from "@/components/ui/EmptyState";
import type { FailureStat } from "../data";

interface Props {
  stats: FailureStat[];
}

export default function FailureReasons({ stats }: Props) {
  const max = stats.length ? stats[0].count : 1;

  return (
    <div className="flex h-full flex-col rounded-[10px] border border-line bg-card p-5 shadow-card">
      <h3 className="text-lg font-semibold text-ink">Failure Reasons</h3>
      {stats.length === 0 ? (
        <div className="mt-4 flex flex-1 items-center justify-center">
          <EmptyState
            icon={CheckCircle2}
            title="No failures in this period"
            description="Every presented installment was collected successfully."
          />
        </div>
      ) : (
        <div className="mt-5 flex flex-col gap-4">
          {stats.map((s) => (
            <div key={s.reason}>
              <div className="flex items-center justify-between gap-3">
                <p className="text-sm text-ink">{s.reason}</p>
                <p className="whitespace-nowrap text-sm font-medium text-ink">
                  {s.count} · {s.percentage}%
                </p>
              </div>
              <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-[#F1F5F9]">
                <div
                  className="h-full rounded-full bg-danger"
                  style={{ width: `${Math.max(4, (s.count / max) * 100)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}